import { IUser } from '@/pages/Users/users.types'
import css from './employeInfoBlock.module.css'
import BackgroundImage from '@/assets/images/employeInfoBlockBackground.svg?react'
import Avatar from '@/shared/Avatar'
import userUtils from '@/pages/User/user.utils'
import Tag from '@/shared/Tags/Tag'
import Button from '@/shared/Buttons/Button'
import AccountPinIcon from '@/assets/icons/accountPinBoxFill.svg?react'
import PhoneIcon from '@/assets/icons/phoneFill.svg?react'
import MailIcon from '@/assets/icons/mailFill.svg?react'
import formatUtils from '@/utils/format.utils'
import CopyButton from '@/shared/Buttons/CopyButton'
import cn from '@/utils/cn'
import Skeleton from '@/shared/Loaders/Skeleton'

interface IProps {
  user: IUser
  loading: boolean
  onEmployeEditClick: (user: IUser) => void
}

const EmployeInfoBlock = (props: IProps) => {
  const renderContent = () => {
    if (props.loading) {
      return (
        <div className="flex-lines gap16" style={{ padding: '0 16px' }}>
          <div className="flex-lines gap4">
            <Skeleton style={{ borderRadius: '4px' }} height="21px" width="30%" />
            <Skeleton style={{ borderRadius: '4px' }} height="24px" width="100%" />
            <Skeleton style={{ borderRadius: '4px' }} height="18px" width="60%" />
          </div>
          <Skeleton style={{ borderRadius: '8px' }} height="32px" width="100%" />
          <div className="flex-lines gap8">
            <Skeleton style={{ borderRadius: '4px' }} height="18px" width="50%" />
          </div>
        </div>
      )
    }

    return (
      <div className="flex-lines gap16" style={{ padding: '0 16px' }}>
        <div className="flex-lines gap4">
          {props.user.active ? <Tag color="green">Активен</Tag> : <Tag color="red">Деактивирован</Tag>}
          <h2 className="text-heading-4">{userUtils.getFullName(props.user.userInfo)}</h2>
          <p className="text-nm text-secondary-strong">{props.user.position || 'Должность не указана'}</p>
        </div>
        <Button
          size="default"
          type="default"
          fullWidth
          text="Редактировать профиль"
          onClick={() => props.onEmployeEditClick(props.user)}
        />
        <div className="flex-lines gap8">
          {props.user.userInfo.telegram && (
            <div className={cn('inline-flex-gap gap8 center', css.contactElement)}>
              <AccountPinIcon height="16px" width="16px" color="var(--text-secondary-strong)" />
              <p className="text-nm text-secondary-strong">{props.user.userInfo.telegram}</p>
            </div>
          )}
          {props.user.userInfo.phoneNumber && (
            <div className={cn('inline-flex-gap gap8 center', css.contactElement)}>
              <PhoneIcon height="16px" width="16px" color="var(--text-secondary-strong)" />
              <p className="text-nm text-secondary-strong">
                {formatUtils.formatPhone(props.user.userInfo.phoneNumber)}
              </p>
              <CopyButton
                text={formatUtils.formatPhone(props.user.userInfo.phoneNumber)}
                messageStyles={{ top: '100%', left: '50%', transform: 'translateX(-50%)' }}
              />
            </div>
          )}
          {props.user.email && (
            <div className={cn('inline-flex-gap gap8 center', css.contactElement)}>
              <MailIcon height="16px" width="16px" color="var(--text-secondary-strong)" />
              <p className="text-nm text-secondary-strong">{props.user.email}</p>
              <CopyButton
                text={props.user.email}
                messageStyles={{ top: '100%', left: '50%', transform: 'translateX(-50%)' }}
              />
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className={css.wrapper}>
      <div className={css.headerElement}>
        <BackgroundImage width="100%" />
        <Avatar
          loading={props.loading}
          size="large"
          wrapperStyle={{
            position: 'absolute',
            top: '32px',
            left: '16px',
            height: '128px',
            width: '128px',
            border: '2px solid var(--border-secondary-color)',
            borderRadius: '16px',
          }}
          skeletonStyle={{ borderRadius: '16px' }}
          initials={<p className="text-heading-1 text-white">{userUtils.getUserAlias(props.user?.userInfo)}</p>}
          userId={props.user?.userInfo.avatar ? props.user?.id : null}
          fileName={props.user?.userInfo.avatar ? props.user?.userInfo.avatar.fileName : null}
        />
      </div>
      {renderContent()}
    </div>
  )
}

export default EmployeInfoBlock
